module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "economy-learning-claims"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "oekonomi.vaerdikaede"
    }
  }), _vm._v("\n            Værdikæde\n        ")], 1), _vm._v(" "), _c('div', {
    staticClass: "placeholder padding"
  }, [(!_vm.loading) ? _c('div', {
    staticClass: "lines"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("\n                        " + _vm._s(_vm.figures.offer.count) + "\n                        tilbud, der afventer afgørelse\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "revenue"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(_vm.figures.offer.expected_revenue)) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "coverage"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(_vm.figures.offer.expected_coverage)) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("\n                        " + _vm._s(_vm.figures.open.count) + "\n                        opgaver, der ikke er påbegyndt\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "revenue"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(_vm.figures.open.expected_revenue)) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "coverage"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(_vm.figures.open.expected_coverage)) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("\n                        " + _vm._s(_vm.figures.ongoing.count) + "\n                        igangværende opgaver, der arbejdes på\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "revenue"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(_vm.figures.ongoing.expected_revenue)) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "coverage"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(_vm.figures.ongoing.expected_coverage)) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("\n                        " + _vm._s(_vm.figures.unbilled.count) + "\n                        afsluttede opgaver, der ikke er fakturerede\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "revenue"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(_vm.figures.unbilled.expected_revenue)) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "coverage"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(_vm.figures.unbilled.expected_coverage)) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("\n                        " + _vm._s(_vm.figures.unpaid_invoices.count) + "\n                        fakturaer, der endnu ikke er betalt\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "revenue"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(_vm.figures.unpaid_invoices.expected_revenue)) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "coverage"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(_vm.figures.unpaid_invoices.expected_coverage)) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("\n                        " + _vm._s(_vm.figures.overdue_invoices.count) + "\n                        fakturaer med overskredet betaling\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "revenue"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(_vm.figures.overdue_invoices.expected_revenue)) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "coverage"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(_vm.figures.overdue_invoices.expected_coverage)) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "line bold"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("Total")]), _vm._v(" "), _c('div', {
    staticClass: "revenue"
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.revenueTotal)))]), _vm._v(" "), _c('div', {
    staticClass: "coverage"
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.coverageTotal)))])])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line bold"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("Pipeline")]), _vm._v(" "), _c('div', {
    staticClass: "revenue"
  }, [_vm._v("Potentiel omsætning")]), _vm._v(" "), _c('div', {
    staticClass: "coverage"
  }, [_vm._v("Potentielt DB")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5d6ac280", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d6ac280"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/economy/learning/revenueAndCosts.vue
// module id = 843
// module chunks = 0